module.exports = __webpack_public_path__ + "static/media/riskScoreTwo.0e9849bc.mp3";